module.exports = __webpack_public_path__ + "static/media/16d-02_Noiromence-1-2016-400x300cm-(dos-paneles-200x300cm-oleo-sobre-panel.70b59b3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16d/16d-02_Noiromence-1-2016-400x300cm-(dos-paneles-200x300cm-oleo-sobre-panel.jpg
// module id = 198
// module chunks = 0